import { decode } from 'html-entities';
import runesData from './runesData.js'

export default function RuneImage(props) {
	if (props.id === undefined) return null;
	return ( 
		<svg xmlns="http://www.w3.org/2000/svg" width="350" height="350">
			<rect width="100%" height="100%" fill="black" />
			<text textAnchor="end" x="345" y="15" style={{fill:"white", fontFamily:"serif", fontSize:"12px"}}>#{props.id}</text>
			{props.runes.map((r, i) => <text key={i} textAnchor="center" x="50%" y={30*i+40} className="rune_text">{decode(runesData[r.value][0])}</text>)}
		</svg> );
}
